export default "__VITE_ASSET__kCdatN32__"